import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ThemContext } from 'layouts/Admin';
import LeaderHistory from './leader';
import HrHistory from './hr';

const History = () => {
  const { isLeader, isAssigner } = useContext(ThemContext);
  const { applyId } = useParams();
  if (isLeader || isAssigner) return <LeaderHistory applyId={applyId} />;
  return <HrHistory applyId={applyId} />;
};

export default History;
